<template>
  <div id="app" :data-lang="$bus.selectedLang.abbr" @click="fixForIOS">
    <header class="header">
      <div class="header-inner">
        <div :class="$bus.is_ind ? 'ff-logo-ind' : 'ff-logo'"></div>
        <toggle-lang />
      </div>
    </header>
    <router-view />
    <footer class="footer">
      <p class="link-text">
        <span @click="checkLink('tos')" class="link-item">{{ transify['YOUTUBE_TOS'] }}</span>
        <span @click="checkLink('pp')" class="link-item">{{ transify['YOUTUBE_PP'] }}</span>
      </p>
      <p class="copyright">Copyright © Garena International.</p>
    </footer>
    <Loading />
    <Alert :show.sync="alertShow" :title="alertTitle" :content="alertContent"/>
  </div>
</template>
<script>
  import { loadStyle, getDefaultLang, initGA, mapState } from '@/utils/assist'
  import ToggleLang from '@/components/toggle-lang/toggle-lang'
  import Loading from '@/components/base/Loading.vue'
  import Alert from '@/components/base/Alert.vue'
  export default {
    data() {
      return {
        globalConfig: this.$bus.$data,
        alertShow: false,
        alertTitle: '',
        alertContent: ''
      }
    },
    computed: {
      ...mapState(['transify', 'isRender', 'selectedLang', 'is_ind']),
    },
    components: {
      Loading,
      ToggleLang,
      Alert
    },
    methods: {
      checkLink(name) {
        window.open(this.selectedLang[name])
        this.$bus.addGA(`check${name}Link`, 'success')
      },
      getCSS() {
        loadStyle('/api/css')
      },
      initInfo() {
        this.$api
          .info()
          .then(response => {
            // NOTE error state has been already handled in request.js
            let data = response.data
            this.$bus.items = data.rewards
            this.$bus.rule.content = data.rules
            this.$bus.is_ind = data.is_ind
            if (this.$bus.is_ind) {
              this.initIndiaLang()
            } else {
              this.initLang()
            }
            this.$bus.login_platform = data.login_platform
            this.$bus.langs.forEach(item => {
              item.transify = Object.assign(
                item.transify,
                data.transify[item.abbr] || data.transify['EN']
              )
            })
            if (data['policy_popup']) {
              const { popup_title: policyTitle, popup_content: policyCtx } = data['policy_popup']
              this.alertShow = localStorage.getItem('policy_popup') !== '1'
              this.alertTitle = policyTitle
              this.alertContent = policyCtx
            }
            this.$bus.indiaLangs.forEach(item => {
              item.transify = Object.assign(
                item.transify,
                data.transify[item.abbr] || data.transify['EN']
              )
            })
            initGA(data.region)
            this.$bus.isRender = true
          })
          .catch(error => {
            // NOTE error has been already handled in request.js
            console.log(error, 'initInfo...')
          })
      },
      initLang() {
        const langTag = getDefaultLang()
        const langIndex = this.$bus.langs.findIndex(item => item.abbr === langTag)
        if (langIndex > -1) {
          this.$bus.langIndex = langIndex
        }
      },
      initIndiaLang() {
        const langTag = getDefaultLang()
        const langIndex = this.$bus.indiaLangs.findIndex(item => item.abbr === langTag)
        if (langIndex > -1) {
          this.$bus.langIndex = langIndex
        }
      },
      // NOTE <=IOS 13 只有注册了点击事件，才能真正触发某些事件
      fixForIOS() {},
      tokenHiding() {
        const searchParams = new URLSearchParams(window.location.search);


        // 2. 删除 access_token 参数
        if (searchParams.has('access_token')) {
          searchParams.delete('access_token');
          // 3. 构建新 URL
          const newUrl = window.location.pathname + (searchParams.toString() ? '?' : '') + searchParams.toString();
          console.log(newUrl,searchParams.toString(), 'tostring');
          // 4. 替换当前 URL（无刷新）
          window.history.replaceState({}, document.title, newUrl);
        } else {
          console.log('noToken');

        }
    }
    },
    created() {
      this.getCSS()
      this.initInfo()
      this.tokenHiding()
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue